var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let Edit = class Edit extends LitElement {
    static { this.styles = css `
    .edit-module {
      position: relative;
      z-index: 101;
      min-height: 5px;
      --mf-edit-module-height: 5px;
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 103;
    }

    .edit-module:hover {
      cursor: pointer;
      z-index: 103;
      min-height: 70px;
      --mf-edit-module-height: 70px;
    }

    .edit-module::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      outline: 3px solid #1b7e4b;
      outline-offset: -3px;
      z-index: 102;
      visibility: hidden;
      opacity: 0;
    }

    .edit-module:hover::after {
      visibility: visible;
      opacity: 1;
    }

    .add-btn {
      padding: 0;
      margin: 0;
      border: 0;
      border-radius: 50%;
      font-size: 0.75rem;
      font-family: system-ui, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji',
        'Segoe UI Emoji';
      font-weight: 600;
      color: white;
      background-color: #1b7e4b;
      cursor: pointer;

      height: 40px;
      width: 40px;
      line-height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      z-index: 104;
      left: 50%;
      transition: background 0.25s ease;
      visibility: hidden;
    }

    .add-btn:hover {
      background-color: #24aa65;
      color: #fff;
    }

    .add-btn:active {
      background-color: #1b7e4b;
      color: #fff;
    }

    .edit-module .add-btn.before {
      top: 0;
      transform: translate(-50%, -50%);
    }

    .edit-module .add-btn.after {
      bottom: 0;
      transform: translate(-50%, 50%);
    }

    .edit-module:hover .add-btn {
      visibility: visible;
    }

    .section-label {
      background: #fff;
      color: #333840;
      position: absolute;
      top: 3px;
      left: 3px;
      line-height: 1;
      font-weight: 600;
      font-size: 0.75rem;
      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
      border: 1px solid #d5d7db;
      border-radius: 0 0 4px 0;
      padding: 4px 7px;
      z-index: 104;
      display: inline-block;
      visibility: hidden;
      opacity: 0;
      font-family: system-ui, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji',
        'Segoe UI Emoji';
    }

    .section-controls {
      position: absolute;
      top: 15px;
      right: 15px;
      z-index: 10;
      display: flex;
      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
      border: 1px solid #d5d7db;
      border-radius: 4px;
      visibility: hidden;
      opacity: 0;
      z-index: 104;
      background: #fff;
    }

    .edit-module:hover .section-controls,
    .edit-module:hover .section-label {
      visibility: visible;
      opacity: 1;
    }

    .section-controls button {
      background: #fff;
      border: 0;
      color: #333840;
      border-left: 1px solid #d5d7db;
      padding: 0;
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition:
        background 0.25s ease,
        border 0.25s ease,
        color 0.25s ease;
    }

    .section-controls button:hover {
      background: #f4f5f7;
    }

    .section-controls button:active {
      background: #fff;
    }

    .section-controls button:first-child {
      border-left: 0;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }

    .section-controls button:last-child {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }

    .section-controls button svg {
      display: block;
    }
    .section-controls button[disabled] {
      pointer-events: none;
      background-color: #f4f5f7;
      color: #afb6c3;
    }
  `; }
    /**
     * Creates an instance of Edit.
     * @constructor
     */
    constructor() {
        super();
    }
    /**
     * Send message to parent window to edit the section
     * @param {string} guid - The guid of the section to edit
     * @returns {void}
     */
    edit(guid) {
        window.parent.postMessage({ type: 'edit', guid: guid, area: this.area });
    }
    /**
     * Send message to parent window to add a new section
     * @param {string} guid - The guid of the section to add before or after
     * @param {string} position - The position to add the new section
     * @returns {void}
     */
    add(guid, position) {
        window.parent.postMessage({ type: 'add', guid: guid, position: position, area: this.area });
    }
    /**
     * Send message to parent window to remove the section
     * @param {string} guid - The guid of the section to remove
     * @returns {void}
     */
    delete(guid) {
        window.parent.postMessage({ type: 'delete', guid: guid });
    }
    /**
     * Send message to parent window to move the section up or dom
     * @param {string} guid - The guid of the section to move
     * @param {string} direction - The direction to move the section up / down
     * @returns {void}
     */
    move(guid, direction) {
        window.parent.postMessage({ type: 'move', guid: guid, direction: direction });
    }
    /**
     * Send message to parent window to copy the section
     * @param {string} guid - The guid of the section to copy
     * @returns {void}
     */
    copy(guid) {
        window.parent.postMessage({ type: 'copy', guid: guid });
    }
    /**
     * Render component
     * @returns {TemplateResult} Template
     */
    render() {
        return html ` <div class="edit-module"> <div class="overlay" @click=${() => this.edit(this.guid)}></div> <div class="section-label">${this.label}</div> <div class="section-controls"> ${this.allowEdit ? html `
                <button title="Edit section" @click=${() => this.edit(this.guid)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-pencil"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325"
                    />
                  </svg>
                </button>
              `
            : ''}
          ${this.allowMove
            ? html ` ${this.allowMoveUp ? html `
                      <button title="Move up" @click=${() => this.move(this.guid, 'up')}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-arrow-up"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5"
                          />
                        </svg>
                      </button>
                    `
                : ''}
                ${this.allowMoveDown
                ? html ` <button title="Move down" @click=${() => this.move(this.guid, 'down')}> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16" > <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1" /> </svg> </button> `
                : ''}
              `
            : ''}
          ${this.allowCopy
            ? html ` <button title="Copy" @click=${() => this.copy(this.guid)}> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-copy" viewBox="0 0 16 16" > <path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z" /> </svg> </button> `
            : ''}
          ${this.allowDelete
            ? html ` <button title="Delete" @click=${() => this.delete(this.guid)}> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16" > <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" /> <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" /> </svg> </button> `
            : ''}
        </div>

        ${this.allowAdd
            ? html ` <button @click=${() => this.add(this.guid, 'before')} class="add-btn before add-block" data-guid=${this.guid} data-position="before" > <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16" > <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" /> </svg> </button> `
            : ''}

        <slot></slot>

        ${this.allowAdd
            ? html ` <button @click=${() => this.add(this.guid, 'after')} class="add-btn after add-block" data-guid=${this.guid} data-position="after" > <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16" > <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" /> </svg> </button> `
            : ''}
      </div>
    `;
    }
};
__decorate([
    property({ type: String })
], Edit.prototype, "guid", void 0);
__decorate([
    property({ type: Boolean, attribute: 'allow-edit' })
], Edit.prototype, "allowEdit", void 0);
__decorate([
    property({ type: Boolean, attribute: 'allow-add' })
], Edit.prototype, "allowAdd", void 0);
__decorate([
    property({ type: Boolean, attribute: 'allow-move' })
], Edit.prototype, "allowMove", void 0);
__decorate([
    property({ type: Boolean, attribute: 'allow-move-up' })
], Edit.prototype, "allowMoveUp", void 0);
__decorate([
    property({ type: Boolean, attribute: 'allow-move-down' })
], Edit.prototype, "allowMoveDown", void 0);
__decorate([
    property({ type: Boolean, attribute: 'allow-copy' })
], Edit.prototype, "allowCopy", void 0);
__decorate([
    property({ type: Boolean, attribute: 'allow-delete' })
], Edit.prototype, "allowDelete", void 0);
__decorate([
    property({ type: String })
], Edit.prototype, "label", void 0);
__decorate([
    property({ type: String })
], Edit.prototype, "area", void 0);
Edit = __decorate([
    customElement('p-edit')
    /**
     * Edit component
     *
     * @class Edit
     * @typedef {Edit}
     * @extends {LitElement}
     */
], Edit);
export { Edit };
